import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { getTimeStamp } from '../../webcommon/common/helpers';

export const INITIAL_STATE = {
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    runDate: '',
    dateFrom: '',
    dateTo: '',
    initialisedMonthlyUpload: false,
    initialisedExport: false,
    initialisedFileAvailability: false,
    fileLoading: false,
    loadingFileAvailability: false,
    loadError:false,
    loadSuccess:false,
    currentServerFilters: null,
    fileName: null,
    fileUploadedAt: null,
    fileUploadRows: [],
    rowsPreview: [],
    isValidated: false,
    validationError: '',
    isUploaded: false,
    waitingForNotification: false,
    rowsFileAvailability: [],
    lastUpdatedFileAvailability: getTimeStamp(),
    gridSorting: [{ gridId: 'timestampSort', gridSort: [{ id: 'createdAt', desc: true }] }]
};
const setRunDate = fp.set('runDate');
const setDateFrom = fp.set('dateFrom');
const setDateTo = fp.set('dateTo');
const setFileAvailabilityInitialised = fp.set('initialisedFileAvailability');
const setFileAvailabilityLoading = fp.set('loadingFileAvailability');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_RUNDATE:
            return setRunDate(action.date, state);     
        case actions.SET_DATE_FROM:
            return setDateFrom(action.date, state);  
        case actions.SET_DATE_TO:
            return setDateTo(action.date, state);     
        case actions.SET_FILE_AVAILABILITY_INITIALISED:
            return setFileAvailabilityInitialised(action.initialised, state);
        case actions.SET_FILE_AVAILABILITY_LOADING:
            return setFileAvailabilityLoading(action.loading, state);     
        case actions.GET_FILE_AVAILABILITY_SUCCESS:{
            return {
                ...state,
                rowsFileAvailability: action.result,
                lastUpdatedFileAvailability: getTimeStamp()
            };
        }
        default:
            return state;
    }
}
